import { render } from "./LikertCompositeQuestion.vue?vue&type=template&id=0d9c4c5c&scoped=true"
import script from "./LikertCompositeQuestion.vue?vue&type=script&lang=js"
export * from "./LikertCompositeQuestion.vue?vue&type=script&lang=js"

import "./LikertCompositeQuestion.vue?vue&type=style&index=0&id=0d9c4c5c&lang=less&scoped=true"

import exportComponent from "C:\\Users\\PC\\AppData\\Local\\Temp\\tecs-enduser-release-cd96384e-20260902-1753\\TECS-FE-ENDUSER-NEW\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d9c4c5c"]])

export default __exports__